/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod';

/**
 * @description OK
 */
export const getMockableUsers200Schema = z.array(
  z.object({
    userId: z.coerce.number().int(),
    name: z.coerce.string(),
    dailyHours: z.coerce.number().int(),
  }),
);

export const getMockableUsersQueryResponseSchema = z.lazy(
  () => getMockableUsers200Schema,
);
